module.exports = __webpack_public_path__ + "static/media/solution.61f4cfa3.svg";